export enum CONTENT_TYPE {
    LESSON = 'lesson',
    QUIZ = 'quiz',
    CATALOG = 'catalog',
    CATALOG_THEME = 'catalog_theme',
    MARKDOWN = 'markdown',
    LINK = 'link',

    // курс-модуль
    COLLECTION = 'collection'
}

export interface LessonViewSettings {
    image: string;
    background: string;
    gradient_colors: {
        colors?: string[];
    } | null;
    lesson_id: number;
    skills: string | null;
    description: string | null;
    teachers_evaluation: number | null;
    /** порядок сортировки блоков */
    order?: number;
}
